import request from '@/utils/request'

// export function fetchList (query) {
//   return request({
//     url: '/user/list',
//     method: 'get',
//     params: query
//   })
// }

// export function fetchDetail (data) {
//   return request({
//     url: '/user/Get',
//     method: 'post',
//     data
//   })
// }

export function checkUser (data) {
  return request({
    url: '/user/CheckUser',
    method: 'post',
    data
  })
}
export function verify (data) {
  return request({
    url: '/user/Verify',
    method: 'post',
    data
  })
}

export function forgetPasswordVerify (data) {
  return request({
    url: '/user/ForgetPasswordVerify',
    method: 'post',
    data
  })
}

export function confirmVerfiy (data) {
  // console.log('api orglogin data', data)
  return request({
    url: '/User/ConfirmVerify',
    method: 'post',
    data
  })
}

export function forgetPassword (data) {
  // console.log('api orglogin data', data)
  return request({
    url: '/User/ForgetPassword',
    method: 'post',
    data
  })
}

// export function createItem (data) {
//   console.log('createItem', data)
//   return request({
//     url: '/user/create',
//     method: 'post',
//     data
//   })
// }

// export function updateItem (data) {
//   console.log('updateItem', data)
//   return request({
//     url: '/user/update',
//     method: 'post',
//     data
//   })
// }

// export function deleteItem (data) {
//   return request({
//     url: '/user/delete',
//     method: 'delete',
//     data
//   })
// }

export function login (data) {
  return request({
    url: '/User/WebLogin',
    method: 'post',
    data
  })
}

export function orgLogin (data) {
  // console.log('api orglogin data', data)
  return request({
    url: '/User/OrganizationLogin',
    method: 'post',
    data
  })
}

export function adminLogin (data) {
  // console.log('api orglogin data', data)
  return request({
    url: '/User/AdminLogin',
    method: 'post',
    data
  })
}

export function orgRegister (data) {
  return request({
    url: '/User/OrganizationRegister',
    method: 'post',
    data
  })
}

// export function getInfo (token) {
//   return request({
//     url: '/user/info',
//     method: 'get',
//     params: { token }
//   })
// }

export function logout () {
  return request({
    url: '/User/Logout',
    method: 'post'
  })
}

export function listDocumentType () {
  return request({
    url: '/User/ListDocumentType',
    method: 'post',
    data: {}
  })
}

export function CreateUserFileAuth (data) {
  return request({
    url: '/User/CreateUserFileAuth',
    method: 'post',
    data
  })
}
